import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ResetPng from "../../Icons/reset.png";
import RestorePng from "../../Icons/restore.png";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "./CommonLoader";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import CommonAlert from "../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../Commonalert/commonErrorAlert";

const RunReportNow = (props) => {
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [loading, Setloading] = useState(false)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({
    name: "",
    path: "",
    closeName: "Close",
    statusDomain: false,
  });
  const [domainNameUrl, setDomainNameUrl] = useState({
    domain_name: "",
    domain_url: "",
  });

  const navigate = useNavigate();

  const RunReportTrigger = () => {

    var RunType = 0;

    if (SoftRunChecked == true) {
      RunType = 1
    }
    else if (HardRunChecked == true) {
      RunType = 0
    }

    RunReportFunction(props.RunReportType, RunType)
    CloseModalTrigger()
  };
  const CloseModalTrigger = () => {
    props.SetRunReportPopShow(false);
  };

  const [HardRunChecked, SetHardRunChecked] = useState(false);
  const [SoftRunChecked, SetSoftRunChecked] = useState(true);

  const SetRunType = (e) => {
    SetHardRunChecked(false);
    SetSoftRunChecked(false);

    if (e.target.value == "hard") {
      SetHardRunChecked(e.target.checked);
    }
    if (e.target.value == "soft") {
      SetSoftRunChecked(e.target.checked);
    }
  };

  const RunReportFunction = async (jobtype = '', runtype = '') => {
    Setloading(false)
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/create_new_job_as_user/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=${jobtype}&soft_run=${runtype}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      Setloading(false)
      if (datavalue.data) {
        if (datavalue.data.message) {

          toast.success(datavalue.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        }
      }
    } catch (err) {
      Setloading(false)
      if (err.response) {

        if (err.response.data.field_error_list) {
          if (err?.response?.status == 599 || err?.response?.status == 400 || err?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(err?.response?.data?.error)
          }
          else if (err?.code == "ERR_NETWORK" || err?.response?.status == 404) {
            navigate('/errorpages')
          }

        }
        else if (err.response.data.error) {
          if (err?.response?.status == 599 || err?.response?.status == 400 || err?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(err?.response?.data?.error)
          }
          else if (err?.code == "ERR_NETWORK" || err?.response?.status == 404) {
            navigate('/errorpages')
          }

        }



      }
      else {
        if (err?.response?.status == 599 || err?.response?.status == 400 || err?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(err?.response?.data?.error)
        }
        else if (err?.code == "ERR_NETWORK" || err?.response?.status == 404) {
          navigate('/errorpages')
        }

      }




      console.log(err);
    }
  };

  const [seconds, setSeconds] = useState(60);
  const [isActive, setIsActive] = useState(false);

  const apihandleClose = () => {
    setapiOpen(false);
  };
  useEffect(() => {
    let interval = null;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds(seconds => seconds - 1);
      }, 1000);
    } else if (isActive && seconds === 0) {
      CloseModalTrigger()
      RunReportTrigger()
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]);


  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios
        .get(`${process.env.REACT_APP_API_URL}accounts/get_user_details/`, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });

      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({
          ...domainNameUrl,
          domain_name: datavalue?.data?.dor_domain_name,
          domain_url: datavalue?.data?.dor_domain_url,
        });
      }

      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({
            ...first,
            name: "Verify Now",
            path: "/Userdata",
            statusDomain: true,
          });
          return;
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({
            ...first,
            name: "Verify Now",
            path: "/Impadddomain",
            statusDomain: true,
          });
          return;
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({
            ...first,
            name: "Verify Now",
            path: "/Domainownership",
            statusDomain: true,
          });
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleStart = () => {
    setIsActive(true);
  };

  const handleReset = () => {
    setIsActive(false);
    setSeconds(60);
  };
  useEffect(() => {

    if (props.RunReportPopShow === true) {
      handleStart()

    }
    if (props.RunReportPopShow === false) {
      handleReset()
    }
    GetuserDatavalue();
  }, [props.RunReportPopShow])


  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />


      {
        loading === true ? <Loader /> : null
      }
      <Dialog
        open={props.RunReportPopShow}
        onClose={CloseModalTrigger}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter run_report_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Choose The Method"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              <div className="run_report_now_modal">
                <div class="main-container">
                  <div class="radio-buttons">
                    <label class="custom-radio">
                      <input
                        type="radio"
                        name="radio"
                        value={"hard"}
                        checked={HardRunChecked}
                        onChange={(e) => {
                          SetRunType(e);
                        }}
                      />
                      <span class="radio-btn">
                        <i class="las la-check"></i>
                        <div class="hobbies-icon">
                          <img src={ResetPng} />
                          <h3 class="">Hard Run</h3>
                        </div>
                      </span>
                    </label>
                    <label class="custom-radio">
                      <input
                        type="radio"
                        name="radio"
                        value={"soft"}
                        checked={SoftRunChecked}
                        onChange={(e) => {
                          SetRunType(e);
                        }}
                      />
                      <span class="radio-btn">
                        <i class="las la-check"></i>
                        <div class="hobbies-icon">
                          <img src={RestorePng} />
                          <h3 class="">Soft Run</h3>
                        </div>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <div className="run_report_info run_soft_text"><b className="">Soft Run:</b> Generates a quick report for known web pages.
          <br />
          <b >Hard Run:</b> Checks for new web pages and runs a complete report.</div>

        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={RunReportTrigger}
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} onClick={CloseModalTrigger}>
            close
          </button>
        </DialogActions>
        <div className="run_report_info run_report_footer">{'The process for running the report will commence automatically after 60 seconds.. Time remaining: ' + seconds}</div>

      </Dialog>
      {/* <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} /> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: false
          }}
          closeAlert={apihandleClose} />
      }
    </>
  );
};
export default RunReportNow;
